<script>
    import { onMount } from "svelte";
    import { infoContent_fi, infoContent_en } from "../scripts/questions";
    import { lang } from "../scripts/stores";
    import Arrow from "./Arrow.svelte";

    export let group;
    export let show;

    let infoContent = $lang === "fi" ? infoContent_fi : infoContent_en;
    let content = infoContent[group - 1];

    $: if($lang) {
        infoContent = $lang === "fi" ? infoContent_fi : infoContent_en;
        content = infoContent[group - 1];
    }
    
    onMount(() => {
        window.scrollTo(0, 0);
    })

</script>

<style>
    p { margin-bottom: 2rem; }
    
    .info-container {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
    }
</style>

<div class="info-container">
    <h3>
        { $lang === "fi" ? "Ohjeita kyselyn seuraavaan osioon" : "Instructions for the next part of the survey" }
    </h3>

    <p>{ content }</p>

    <button class="btn btn-primary" on:click={ () => show = false }>
        { $lang === "fi" ? "Jatka kyselyä" : "Continue" }
        <Arrow />
    </button>
</div>